import React, { useMemo, useRef } from "react"

import { TableAPI } from "shared/ui/table/types"

interface TableAPIContextType {
  tableAPIRef: React.RefObject<TableAPI | null> | null
}

export const TableAPIContext = React.createContext<TableAPIContextType>({
  tableAPIRef: null
})

export const TableAPIContextProvider = React.memo(
  ({ children }: { children: React.ReactNode | React.ReactNode[] }) => {
    const tableAPIRef = useRef<TableAPI>(null)
    const contextValue: TableAPIContextType = useMemo(
      () => ({ tableAPIRef }),
      []
    )

    return (
      <TableAPIContext.Provider value={contextValue}>
        {children}
      </TableAPIContext.Provider>
    )
  }
)
